import React from 'react'
import { TestContainerStyled } from './styled'
import { Section, RadarGraph } from '../../components'

export class TestContainer extends React.Component {
  render() {
    const data = [
      {
        subject: 'Math',
        A: 1,
        fullMark: 5,
      },
      {
        subject: 'Chinese',
        A: 2,
        fullMark: 5,
      },
      {
        subject: 'English',
        A: 3,
        fullMark: 5,
      },
    ]

    return (
      <TestContainerStyled className="test-page">
        <Section>
          <RadarGraph data={data} />
        </Section>
      </TestContainerStyled>
    )
  }
}
